import Main from "@/components/main";
import subMain from "@/components/subMain";
import jRouter from "./j-routers.js";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true,
      nameText: "router.index.login"
    },
    component: () => import("@/view/login/login.vue")
  },
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true,
      nameText: "router.index.home"
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: true,
          title: "首页",
          notCache: true,
          icon: "md-home",
          nameText: "router.index.home"
        }
        // redirect: '/user/userInformation',
        // component: () => import('@/view/home/homePage.vue')
      }
    ]
  },
  // 用户管理
  {
    path: "/user",
    name: "userInformation",
    component: Main,
    meta: {
      title: "用户查询管理",
      nameText: "router.index.pageSearch1",
      id: 1,
      version: 1
    },
    children: [
      {
        path: "userInformation",
        name: "用户查询",
        meta: {
          title: "用户查询",
          nameText: "router.index.pageSearch2",
          version: 1,
          id: 1,
        },
        component: () => import("@/view/userInformation/userInformation.vue")
      },
      {
        path: "userInformation/userDetail",
        name: "用户详情",
        meta: {
          title: "用户详情",
          nameText: "router.index.pageSearch3",
          version: 1,
          id: 1,
          sideMenuItemHidden: true // 在侧边栏隐藏该页面跳转链接
        },
        component: () => import("@/view/userInformation/userData.vue")
      },
      {
        path: "labelManagement",
        name: "用户标签管理",
        meta: {
          title: "用户标签管理",
          nameText: "views.userInformation.btnTxt",
          version: 1,

          sideMenuItemHidden: true // 在侧边栏隐藏该页面跳转链接
        },
        component: () => import("@/view/userInformation/label.vue")
      }
    ]
  },
  // 房间管理
  {
    path: "/service",
    name: "roomManagement",
    component: Main,
    meta: {
      // hideInBread: true,
      title: "房间管理",
      nameText: "router.index.pageRoom1",
      version: 1,

      id: 37
    },
    children: [
      {
        path: "roomManagement",
        name: "房间查询",
        meta: {
          title: "房间查询",
          nameText: "router.index.pageRoom2",
          version: 1,
          id:38
        },
        // component: () => import("@/view/roomManagement/index.vue")
        component: () => import("@/view/roomManagement/roomManagement/management.vue")
      },
      {
        path: "roomDetail",
        name: "房间详情",
        meta: {
          title: "房间详情",
          nameText: "router.index.pageRoom2",
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          version: 1,
          id:38
        },
        component: () =>
          import("@/view/roomManagement/management/roomDetail.vue")
      },
      {
        path: "roomLabel",
        name: "房间标签管理",
        meta: {
          title: "房间标签管理",
          nameText: "router.index.pageRoom3",
          version: 1,
          id:38,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/management/roomLabel.vue")
      },
      {
        path: "notList",
        name: "未发放列表",
        meta: {
          title: "未发放列表",
          nameText: "router.index.notList",
          version: 1,
          id:40,

          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomManagement/notlist.vue")
      },
      {
        path: "supportBlacklist",
        name: "扶持黑名单",
        meta: {
          title: "扶持黑名单",
          nameText: "router.index.supportBlacklist",
          version: 1,
          id:40,

          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomManagement/supportBlacklist.vue")
      },

      {
        path: "roomBgEdit",
        name: "房间背景编辑",
        meta: {
          title: "房间背景编辑",
          nameText: "router.index.pageRoom5",
          version: 1,
          id:79,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/management/roomBgEdit.vue")
      },
      // {
      //   path: "auditManage",
      //   name: "审核管理",
      //   meta: {
      //     title: "房间审核管理",
      //     nameText: "router.index.pageRoom6",
      //     version: 1,
      //     id:48
      //
      //     // sideMenuItemHidden: true,
      //   },
      //   component: () =>
      //     import("@/view/roomManagement/management/auditManage/auditManageActive.vue")
      // },
      {
        path: "roomOwner",
        name: "房主认证",
        meta: {
          title: "房主认证",
          nameText: "router.index.pageRoom7",
          version: 1,
          id: 37,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/management/roomOwner.vue")
      },
      {
        path: "roomRunning/:id",
        name: "房间流水详情",
        meta: {
          title: "房间流水详情",
          nameText: "router.index.pageRoom8",
          version: 1,
          id:136,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomRunning/roomRunningDetail.vue")
      },
      {
        path: "roomHourlyFlow/:user_id/:room_id",
        name: "房间整点流水",
        meta: {
          title: "房间整点流水",
          nameText: "router.index.pageRoom13",
          version: 1,
          id:136,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomRunning/roomHourlyFlow.vue")
      },
      {
        path: "listening",
        name: "监控房间列表",
        meta: {
          title: "监控房间列表",
          nameText: "router.index.pageRoom9",
          version: 1,
          id: 37,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomRunning/listening.vue")
      },
      {
        path: "roomReception",
        name: "房间接待",
        meta: {
          title: "房间接待",
          nameText: "router.index.pageRoom10",
          version: 1,
          id: 37,

          sideMenuItemHidden: true
        },
        component: () => import("@/view/roomManagement/roomReception/index.vue")
      },
      {
        path: "roomReceptionDetail",
        name: "房间接待详情",
        meta: {
          title: "房间接待详情",
          nameText: "router.index.pageRoom12",
          version: 1,
          id: 41,

          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/roomReception/receptDetail.vue")
      },

      {
        path: "supportList",
        name: "活动奖励列表",
        meta: {
          title: "活动奖励列表",
          nameText: "views.activitiesSupport.text29",
          version: 1,
          id: 49,

          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/roomManagement/management/activitiesSupport/list.vue")
      },
      {
        path: 'pattyGame',
        name: 'pattyGame',
        meta: {
          title: '派对数据统计',
          nameText: '派对数据统计',
          id: 376,
        },
        component: () => import('@/view/gameStatistics/pattyGame/index.vue'),
      },
      {
        path: "roomSupport",
        name: "房间扶持",
        meta: {
          title: "房间扶持",
          nameText: "房间扶持",
          version: 1,
          id: 375,

        },
        component: () =>
          import("@/view/roomManagement/roomSupport/index.vue")
      },

      {
        path: "roomBotText",
        name: "Bot话题库管理",
        meta: {
          title: "Bot话题库管理",
          nameText: "Bot话题库管理",
          version: 1,
          id: 375,

        },
        component: () =>
          import("@/view/roomManagement/botManagement/textBotIndex.vue")
      },
      {
        path: "roomBotImg",
        name: "Bot图库管理",
        meta: {
          title: "Bot图库管理",
          nameText: "Bot图库管理",
          version: 1,
          id: 375,

        },
        component: () =>
          import("@/view/roomManagement/botManagement/imgBotIndex.vue")
      },

    ]
  },
  //部落管理
  {
    path: "/tribe",
    name: "tribeManagement",
    component: Main,
    meta: {
      // hideInBread: true,
      title: "部落管理",
      nameText: "部落管理",
      version: 1,

      id: 412
    },
    children: [
      {
        path: "tribeList",
        name: "部落管理",
        meta: {
          title: "部落管理",
          nameText: "部落管理",
          version: 1,
          id: 412
        },
        component: () => import("@/view/tribeManagement/tribeList.vue")
      },
      {
        path: "tribeDetail",
        name: "部落详情",
        meta: {
          title: "部落详情",
          nameText: "部落详情",
          version: 1,
          sideMenuItemHidden: true,
          id: 412
        },
        component: () => import("@/view/tribeManagement/tribeDetail.vue")
      },
    ]
  },
  // 代理管理
  {
    path: "/agentManagement",
    name: "agentManagement",
    component: Main,
    meta: {
      title: "代理管理",
      nameText: "router.index.pageAgent1",
      id: 89,
      version: 10
    },
    children: [
      {
        path: "home",
        name: "代理管理",
        meta: {
          title: "代理管理",
          version: 10,
          id: 89,
          nameText: "router.index.pageAgent1"
        },
        component: () => import("@/view/agentManagement/index.vue")
      },
      {
        path: "recharge/:userId/:agentNo/:dayType",
        name: "ta的充值记录",
        meta: {
          title: "ta的充值记录",
          version: 10,
          id: 89,
          nameText: "router.index.pageAgent2",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/recharge.vue")
      },
      {
        path: "whiteList",
        name: "充值白名单",
        meta: {
          title: "充值白名单",
          version: 10,
          id: 94,
          nameText: "views.agentManagement.table1Text15",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/whiteList.vue")
      },
      {
        path: "agentList/:userId",
        name: "代理充值列表",
        meta: {
          title: "代理充值列表",
          version: 10,
          id: 89,
          nameText: "router.index.pageAgent3",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/agentList.vue")
      },
      {
        path: "monthlySales",
        name: "月度销售统计",
        meta: {
          title: "月度销售统计",
          version: 10,
          id: 89,
          nameText: "router.index.pageAgent4",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/monthlySales.vue")
      },
      {
        path: "SubDetails/:userId",
        name: "订阅余额明细",
        meta: {
          title: "订阅余额明细",
          version: 10,
          id: 89,
          nameText: "router.index.bindList",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/bindList.vue")
      },
      {
        path: "bindList/:userId",
        name: "绑定名单列表",
        meta: {
          title: "绑定名单列表",
          version: 10,
          id: 97,
          nameText: "router.index.pageAgent3",
          hideInMenu: true
        },
        component: () => import("@/view/agentManagement/bindList.vue")
      },
    ]
  },
  // 国家管理员管理
  {
    path: "/countryAdmin",
    name: "countryAdmin",
    component: Main,
    meta: {
      title: "国家管理员管理",
      nameText: "国家管理员管理",
      id: 379,
      version: 1
    },
    children: [
      {
        path: "home",
        name: "国家管理员管理",
        meta: {
          title: "国家管理员管理",
          version: 1,
          id: 379,
          nameText: "国家管理员管理",
        },
        component: () => import("@/view/countryAdmin/index.vue")
      }
    ]
  },
  // 推广员管理
  {
    path: "/promoter",
    name: "promoter",
    component: Main,
    meta: {
      title: "拉新系统管理",
      nameText: "拉新系统管理",
      id: 370,
      version: 1
    },
    children: [
      {
        path: "dataBoard",
        name: "大盘数据",
        meta: {
          title: "大盘数据",
          nameText: "大盘数据",
          id: 371
        },
        component: () => import("@/view/promoter/dataBoard/index.vue")
      },
      {
        path: "usdRank",
        name: "美金收益榜",
        meta: {
          title: "美金收益榜",
          nameText: "美金收益榜",
          id: 372
        },
        component: () => import("@/view/promoter/usdRank/index.vue")
      },
      {
        path: "goldRank",
        name: "金币收益榜",
        meta: {
          title: "金币收益榜",
          nameText: "金币收益榜",
          id: 373
        },
        component: () => import("@/view/promoter/goldRank/index.vue")
      },
      {
        path: "promoterList",
        name: "新推广员列表",
        meta: {
          title: "新推广员列表",
          nameText: "新推广员列表",
          id: 374
        },
        component: () => import("@/view/promoter/promoterList/index.vue")
      },
      {
        path: "failList",
        name: "拉新记录查询",
        meta: {
          title: "拉新记录查询",
          nameText: "拉新记录查询",
          id: 377
        },
        component: () => import("@/view/promoter/failList/index.vue")
      },
    ]
  },
  // 金币发放管理
  {
    path: "/sendCoins",
    name: "sendCoins",
    component: Main,
    meta: {
      title: "金币发放管理",
      nameText: "sendCoins.send_coin_management",
      id: 82,
      version: 1
    },
    children: [
      {
        path: "sendCoins",
        name: "金币发放管理列表",
        meta: {
          title: "金币发放管理列表",
          version: 1,
          nameText: "金币发放",
          id: 82
        },
        component: () => import("@/view/sendCoinsManagement/index.vue")
      },
    ]
  },
  // 平台数据统计
  {
    path: '/platform-operation',
    name: 'platform-operation',
    component: Main,
    meta: {
      title: '平台运营数据',
      nameText: 'router.index.pageData',
      id: 316,
    },
    children: [

      {
        path: 'listAll',
        name: '全区运营数据',
        meta: {
          title: '全区运营数据',
          nameText: 'router.index.pagePlatformAll',
          id: 369,
        },
        component: () => import('@/view/platform-operation/index.vue'),
      },
      {
        path:'rTrackInterList',
        name:'大R互动榜',
        meta: {
          title: '大R互动榜',
          nameText: '大R互动榜',
          id: 369,
          sideMenuItemHidden:true,
        },
        component: () => import('@/view/platform-operation/rTrackList/interActiveList.vue'),
      },
      {
        path:'sendCoinsStatistic',
        name:'金币发放统计',
        meta: {
          title: '金币发放统计',
          nameText: '金币发放统计',
          id: 409,
        },
        component: () => import('@/view/dataStatistics/sendCoinsStatistic/index.vue'),
      },
      {
        path:'luckyGameStatistic',
        name:'玩家幸运游戏亏损统计',
        meta: {
          title: '玩家幸运游戏亏损统计',
          nameText: '玩家幸运游戏亏损统计',
          id: 416,
        },
        component: () => import('@/view/dataStatistics/luckyGameStatistic/index.vue'),
      },
      // {
      //   path: 'gameStatistics',
      //   name: '游戏数据看板',
      //   meta: {
      //     title: '游戏数据看板',
      //     nameText: 'router.index.gameStatistics',
      //     id: 349,
      //     // hideInMenu: true
      //   },
      //   component: () => import('@/view/gameStatistics/dashboard/index.vue'),
      // },
      // {
      //   path: 'guildStatistics',
      //   name: '公会统计',
      //   meta: {
      //     title: '公会统计',
      //     nameText: 'router.index.guildStatistics',
      //     id: 329,
      //     // id: [536, 550, 551, 552, 553, 554, 555, 556, 557],
      //   },
      //   component: () => import('@/view/guildStatistics/index.vue'),
      // },
      {
        path: 'treasure-hunt',
        name: 'treasure-hunt',
        meta: {
          title: '水果机统计',
          nameText: 'router.index.pageTreasureHunt1',
          id: 322,
        },
        component: () => import('@/view/treasure-hunt/index.vue'),
      },
      {
        path: 'foodie',
        name: 'foodie',
        meta: {
          title: 'Foodie统计',
          nameText: 'router.index.foodie',
          id: 338,
        },
        component: () => import('@/view/dataStatistics/foodie/index.vue'),
      },
      {
        path: 'greedyCat',
        name: 'greedyCat',
        meta: {
          title: 'greedyCat统计',
          nameText: 'greedyCat统计',
          id: 381,
        },
        component: () => import('@/view/dataStatistics/greedyCat/index.vue'),
      },

      {
        path: 'slots',
        name: 'slots',
        meta: {
          title: 'slots',
          nameText: 'slots',
          id: 341,
        },
        component: () => import('@/view/gameStatistics/slots/index.vue'),
      },
      {
        path: 'lucky77',
        name: 'lucky77',
        meta: {
          title: 'lucky77',
          nameText: 'lucky77',
          id: 382,
        },
        component: () => import('@/view/gameStatistics/lucky77/index.vue'),
      },
      {
        path: 'candy',
        name: 'candy',
        meta: {
          title: 'Candy',
          nameText: 'Candy',
          id: 342,
        },
        component: () => import('@/view/gameStatistics/candy/index.vue'),
      },
      {
        path: 'fruit77',
        name: 'fruit77',
        meta: {
          title: 'fruit77',
          nameText: 'fruit77',
          id: 383,
        },
        component: () => import('@/view/gameStatistics/fruit77/index.vue'),
      },
      {
        path: 'magicSphinx',
        name: 'magicSphinx',
        meta: {
          title: 'magic Sphinx',
          nameText: 'magic Sphinx',
          id: 343,
        },
        component: () => import('@/view/gameStatistics/magicSphinx/index.vue'),
      },
      // {
      //   path: 'greedy',
      //   name: 'Greedy',
      //   meta: {
      //     title: 'Greedy',
      //     nameText: 'Greedy',
      //     id: 343,
      //   },
      //   component: () => import('@/view/gameStatistics/greedy/index.vue'),
      // },
      {
        path: 'sudGame',
        name: 'sudGame',
        meta: {
          title: '休闲游戏统计',
          nameText: '休闲游戏统计',
          id: 367,
        },
        component: () => import('@/view/gameStatistics/sudGame/index.vue'),
      },


    ]
  },
  // 充值风控管理
  {
    path: "/riskControl",
    name: "riskControl",
    component: Main,
    meta: {
      title: "充值风控管理",
      nameText: "router.index.riskControl",
      version: 1,

      id: 122
    },
    children: [
      {
        path: "index",
        name: "充值风控管理",
        meta: {
          title: "充值风控管理",
          nameText: "router.index.riskControl",
          version: 1,
          id: 125
        },
        component: () => import("@/view/riskcontrolManagement/index.vue")
      }
    ]
  },
  // 广告
  {
    path: "/ad",
    name: "ad",
    component: Main,
    meta: {
      title: "广告管理",
      nameText: "router.index.pageAd",
      version: 1,

      id: 58
    },
    children: [
      {
        path: "index",
        name: "广告管理",
        meta: {
          title: "广告管理列表",
          nameText: "router.index.pageAd",
          version: 1,
          id: 53
        },
        // component: () => import("@/view/roomColumn/foundPage.vue")
        component: () => import("@/view/ad/index.vue")
      }
    ]
  },
  // 系统消息管理
  {
    path: "/systemMessage",
    name: "systemMessage",
    component: Main,
    meta: {
      title: "系统消息管理",
      nameText: "router.index.systemMessage",
      id: 54,
      version: 1
    },
    children: [
      {
        path: "index",
        name: "系统消息管理",
        meta: {
          title: "系统消息管理",
          version: 1,
          id: 54,
          nameText: "router.index.sendMessage"
        },
        component: () => import("@/view/systemMessage/index.vue")
      }
    ]
  },
  // 活动管理
  {
    path: "/activityManagement",
    name: "activityManagement",
    component: Main,
    meta: {
      title: "活动管理",
      nameText: "router.index.ActivityManagement",
      id: 357,
      version: 10
    },
    children: [
      // zjy 20210707 s
      {
        path: "mangement",
        name: "活动管理",
        meta: {
          title: "活动管理",
          nameText: "router.index.ActivityManagement_1",
          // sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          version: 10,
          id:358
        },
        component: () =>
          import("@/view/activityManagement/mangement/activityList.vue")
      },
      {
        path: "activityDeploy",
        name: "activityDeploy",
        meta: {
          title: "活动配置",
          nameText: "router.index.activityDeploy",
          version: 10,
          id:364
        },
        component: () => import("@/view/activityDeploy/index.vue")
      },
      {
        // /:teamId
        path: "taskDeploy/:code/:id/:teamId",
        name: "taskDeploy",
        meta: {
          title: "任务配置",
          nameText: "router.index.taskDeploy",
          hideInBread: true,
          sideMenuItemHidden: true,
          id:364
        },
        component: () => import("@/view/activityDeploy/taskIndex.vue")
      },
      {
        path: "blacklistManagement",
        name: "黑名单管理",
        meta: {
          title: "黑名单管理",
          nameText: "router.index.activityBlackListManagement",
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          version: 10,
          id:65
        },
        component: () =>
          import("@/view/activityManagement/mangement/blacklistManagement.vue")
      },
      {
        path: "shieldList",
        name: "屏蔽名单",
        meta: {
          title: "屏蔽名单",
          nameText: "router.index.activityShieldManagement",
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          version: 10,
          id:65
        },
        component: () =>
          import("@/view/activityManagement/mangement/shieldlist.vue")
      },
      // zjy
      // e


      // p2


      {
        path: "blacklist",
        name: "黑名单",
        meta: {
          title: "黑名单",
          nameText: "activity_management.text5",
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          version: 16,
          id:65
        },
        component: () =>
          import("@/view/activityManagement/mangement/blacklist.vue")
      },

      {
        path: "templateActivity",
        name: "模板活动",
        meta: {
          title: "模板活动",
          nameText: "router.index.templateActivity",
          version: 1,
          id:366
        },
        component: () =>
          import("@/view/activityManagement/templateAct/index.vue")
      },
      {
        path: "tempActTask",
        name: "模板活动任务配置",
        meta: {
          title: "模板活动任务配置",
          nameText: "router.index.templateActTask",
          version: 1,
          id:366,
          sideMenuItemHidden: true
        },
        component: () =>
          import("@/view/activityManagement/templateAct/tempActTask.vue")
      },


    ]
  },
  // 道具
  {
    path: "/props",
    name: "props",
    component: Main,
    meta: {
      title: "礼物道具管理",
      nameText: "router.index.pageProps1",
      version: 1,
      id: 78
    },
    children: [
      // 礼物信息查询
      {
        // path: "/gift/giftInformation",
        path: "giftInformation",
        name: "礼物信息查询",
        meta: {
          // hideInBread: true,
          title: "礼物信息查询",
          version: 1,
          nameText: "router.index.pageGift1",
          id: 79
        },
        component: () => import("@/view/giftInformation/index.vue")
      },
      // 道具
      {
        path: "index",
        name: "道具商城列表",
        meta: {
          title: "道具商城列表",
          version: 1,
          id: 80,

          nameText: "router.index.pageProps2"
        },
        component: () => import("@/view/itemsMall/index.vue")
      },
      {
        path: "relationshipGift",
        name: "关系信物管理",
        meta: {
          title: "关系信物管理",
          version: 1,
          id: 408,

          nameText: "关系信物管理"
        },
        component: () => import("@/view/giftInformation/relationshipGift/index.vue")
      },
      // 表情管理
      {
        path: "faceManagement",
        name: "表情管理",
        meta: {
          // hideInBread: true,
          title: "表情管理",
          version: 1,
          nameText: "router.index.faceManagement",
          id: 79
        },
        component: () => import("@/view/giftInformation/faceManagement/index.vue")
      },
      {
        path: "coupons",
        name: "卡券",
        meta: {
          title: "卡券",
          version: 1,
          id: 81,

          nameText: "router.index.pageProps4"
        },
        component: () => import("@/view/itemsMall/coupons.vue")
      },
      {
        path: "rocketConfig",
        name: "火箭配置",
        meta: {
          title: "火箭配置",
          version: 1,
          id: 81,

          nameText: "火箭配置"
        },
        component: () => import("@/view/giftInformation/rocketConfig/index.vue")
      },


      // {
      //   path: "user-list",
      //   name: "用户列表",
      //   meta: {
      //     title: "用户列表",
      //     version: 1,
      //     id: 84,
      //
      //     nameText: "router.index.pageProps5",
      //     sideMenuItemHidden: true
      //   },
      //   component: () => import("@/view/itemsMall/userList.vue")
      // }
    ]
  },

  // 公会管理
  {
    path: "/bdManagement",
    name: "bdManagement",
    component: Main,
    meta: {
      title: "公会管理",
      nameText: "router.index.guildManagement",
      version: 10,
      id: 330,
    },
    children: [
      {
        path: "bdManagementIndex",
        name: "BD管理",
        meta: {
          title: "BD管理",
          nameText: "router.index.bdManagement",
          version: 10,
          id: 344
        },
        component: () =>
          import("@/view/bdManagement/index.vue")
      },
    ],
  },
  {
    path: "/newUserReview",
    name: "newUserReview",
    component: Main,
    meta: {
      title: "欢迎派对申请管理",
      nameText: "router.index.newUserReview",
      version: 10,
      id: 350,
    },
    children: [
      {
        path: "newUserReview",
        name: "欢迎派对申请管理",
        meta: {
          title: "欢迎派对申请管理",
          nameText: "router.index.newUserReview",
          version: 10,
          id: 350
        },
        component: () =>
          import("@/view/newUserReview/index.vue")
      },
    ],
  },
  {
    path: "/community",
    name: "community",
    component: Main,
    meta: {
      title: "动态广场",
      nameText: "动态广场",
      version: 10,
      id: 380,
    },
    children: [
      {
        path: "reportManagement",
        name: "动态广场",
        meta: {
          title: "动态广场",
          nameText: "动态广场",
          version: 10,
          id: 380
        },
        component: () =>
          import("@/view/community/reportManagement/reportManagement.vue")
      },
    ],
  },
  // 音乐库
  {
    path: "/music",
    name: "music",
    component: Main,
    meta: {
      title: "音乐库",
      nameText: "音乐库",
      id: 411,
    },
    children: [
      {
        path: "musicLib",
        name: "音乐库管理",
        meta: {
          title: "音乐库管理",
          nameText: "音乐库管理",
          id: 411
        },
        component: () =>
          import("@/view/musicLibs/index.vue")
      }
    ]
  },
  // 设置
  {
    path: "/setting",
    name: "setting",
    component: Main,
    meta: {
      title: "设置",
      nameText: "router.index.setting",
      id: 140,
      version: 10
    },
    children: [
      {
        path: "account",
        name: "管理员账号设置列表",
        meta: {
          title: "管理员账号设置列表",
          version: 1,
          nameText: "router.index.pageAccount2",
          id: 131
        },
        component: () => import("@/view/account/account.vue")
      },
      {
        path: "authorityManagement",
        name: "角色权限管理列表",
        meta: {
          title: "角色权限管理列表",
          nameText: "router.index.pageManagement2",
          version: 1,
          id: 135,
        },
        component: () =>
          import("@/view/authorityManagement/authorityManagement.vue")
      },
      {
        path: "module",
        name: "模块权限管理",
        meta: {
          title: "模块权限管理",
          hideInMenu: true,
          version: 1,
          id: 135,
          nameText: "views.authorityManagement.text1"
        },
        component: () =>
          import("@/view/authorityManagement/modulePermissions.vue")
      },
      {
        path: "propsLimit",
        name: "道具限制管理",
        meta: {
          title: "道具限制管理",
          hideInMenu: true,
          version: 1,
          id: 135,
          nameText: "views.authorityManagement.text6"
        },
        component: () => import("@/view/authorityManagement/propsLimit.vue")
      },

      {
        path: "countryList",
        name: "国家列表",
        meta: {
          title: "国家列表",
          version: 10,
          id: 147,

          nameText: "国家&区域"
        },
        component: () => import("@/view/countryManagement/list.vue")
      },


      {
        path: "versionSet",
        name: "版本号设置",
        meta: {
          title: "版本号设置",
          version: 10,
          id: 148,

          nameText: "版本号设置"
        },
        component: () => import("@/view/setting/version.vue")
      },

      {
        path: "feedbackList",
        name: "feedbackList",
        meta: {
          title: "反馈列表",
          version: 10,
          hideInMenu: true,
          id:148,

          nameText: "router.index.feedbackList"
        },
        component: () => import("@/view/setting/components/feedbackList.vue")
      },
      {
        path: "managementList",
        name: "managementList",
        meta: {
          title: "管理列表",
          version: 10,
          hideInMenu: true,
          id:148,

          nameText: "router.index.managementList"
        },
        component: () => import("@/view/setting/components/managementList.vue")
      },
      {
        path: "clientLog",
        name: "clientLog",
        meta: {
          title: "用户BUG日志查询",
          version: 1,
          id:410,

          nameText: "用户BUG日志查询"
        },
        component: () => import("@/view/setting/clientLog/index.vue")
      }
    ]
  },
  // 操作日志
  {
    path: "/operationLog",
    name: "operationLog",
    component: Main,
    meta: {
      title: "操作日志",
      nameText: "router.index.operationLog1",
      id: 149,
      version: 1
    },
    children: [
      {
        path: "home",
        name: "操作日志列表",
        meta: {
          title: "操作日志列表",
          version: 1,
          id: 149,
          nameText: "router.index.operationLog1"
        },
        component: () => import("@/view/operationLog/operationLog.vue")
      }
    ]
  },

  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error401"
    },
    component: () => import("@/view/error-page/401.vue")
  },
  {
    path: "/500",
    name: "error_500",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error500"
    },
    component: () => import("@/view/error-page/500.vue")
  },
  {
    path: "*",
    name: "error_404",
    meta: {
      hideInMenu: true,
      nameText: "router.index.error404"
    },
    component: () => import("@/view/error-page/404.vue")
  }

  //

  //
];



// WEBPACK FOOTER //
// ./src/router/routers.js